module.exports = __webpack_public_path__ + "img/agsat-logo.e180e6d2.jpg";